/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'vh-match-rule-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Rule',
    [modalTitleNew]: 'New Rule',
};
